<template>
  <v-row no-gutters align="center" justify="center">
    <v-col cols="2"></v-col>
    <v-col cols="8">
      <v-row no-gutters align="center" justify="center">
        <v-col cols="3" align="center" v-for="(language, i) in languages" :key="i" class="mx-8">
          <v-badge color="green" content="Selected" v-if="getCurrentLanguage === language.code" overlap>
            <v-card height="60px" width="160px" @click="changeLanguage(language.code)" class="btnDim">
              <v-row no-gutters>
                <v-col cols="4">
                  <v-img :src="language.imageUrl" width="40" height="35" contain></v-img>
                </v-col>
                <v-col cols="8" class="text-h6 font-weight-bold primary--text">
                  {{ language.name }}
                </v-col>
              </v-row>
            </v-card>
          </v-badge>
          <v-card v-else height="60px" width="160px" @click="changeLanguage(language.code)" class="btnDim">
            <v-row no-gutters>
              <v-col cols="4">
                <v-img :src="language.imageUrl" width="40" height="35" contain></v-img>
              </v-col>
              <v-col cols="8" class="text-h6 font-weight-bold primary--text">
                {{ language.name }}
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="2"></v-col>
    <!-- <v-col align-self="right" cols="2">
      <v-img src="@/assets/ada.png" width="125" contain @click="$store.commit('setEnableADA', true)"
        v-if="!getenableADA"></v-img>
      <v-btn fab color="#0443cc" v-else @click="$store.commit('setEnableADA', false); adaTracking()" width="80"
        height="80" class="ma-0 pa-0">
        <v-icon color="white" size="45">mdi-restore</v-icon>
      </v-btn>

    </v-col> -->
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "languageBar",
  data() {
    return {
      languages: [
        { name: 'English', code: 'en', imageUrl: require('@/assets/usa.png') },
        { name: 'Español', code: 'es-US', imageUrl: require('@/assets/mexican.png') },
      ]
    }
  },
  computed: {
    ...mapGetters(["getTouchCount", "getCurrentLanguage", "getLanguages", "getenableADA", "getKioskProfile", "getTouchCount", "getGreetingStatus"]),
  },
  methods: {
    pullLanguage(code) {
      return this.languages.filter(lang => lang.code === code)[0].name
    },
    adaTracking() {
      this.$store.commit("setTouchRequest", {
        module: "General",
        action: "ADA",
        response: "ADA enabled",
        timeStamp: new Date(),
        requestType: "Touch",
      });
    },
    changeLanguage(language) {
      this.$store.commit('setRequestQna', false)
      this.$store.commit("setIsThinking", false)
      this.$store.commit("setSpeechRecognitionHandler", false);
      this.$store.commit("setTouchCount", this.getTouchCount + 1);
      if (this.getTouchCount === 1 && !this.getGreetingStatus) {
        this.$store.commit("setTouchRequest", {
          module: "Default",
          action: "Touch Detected",
          response: "User Session Started - Touch Detected",
          timeStamp: new Date(),
          requestType: "Session",
        });
        this.$store.dispatch('addInteractionToPostgres', { actionType: 'Session Started', actionPayload: { recognitionType: 'Touch' } })
      }
      switch (language) {
        case "en":
          this.$i18n.locale = "en";
          this.$store.commit("setCurrentLanguage", "en");
          this.$store.dispatch("avatarSpeak", "I am now speaking in English.");
          this.$store.dispatch('setDefaults')
          this.$store.dispatch("identifyAvatarLangCodes", "en");
          this.$store.commit("setSpeechRecognitionLanguage", "en-US")
          this.$store.commit("setDefaultLocation", this.$i18n.t("maps").filter(map => map.displayPosition.toString() === this.getKioskProfile.data().defaultLocation)[0].mapName)
          this.$store.commit("setTouchRequest", {
            module: "Language Bar",
            action: "Change Language",
            response: "Language changed to English",
            timeStamp: new Date(),
            requestType: "Touch",
          });
          break;
        case "es-US":
          this.$store.dispatch('avatarSpeak', 'La versión en español está en desarrollo.');
          this.$i18n.locale = "es";
          this.$store.commit("setCurrentLanguage", "es-US");
          this.$store.dispatch('avatarSpeak', 'Ahora estoy hablando en español.');
          this.$store.dispatch('setDefaultsSpanish')
          this.$store.dispatch("identifyAvatarLangCodes", "es-US");
          this.$store.commit("setSpeechRecognitionLanguage", "es-US")

          console.log('Default Location from firebase: ', this.getKioskProfile.data().defaultLocation)
          this.$store.commit("setDefaultLocation", this.$i18n.t("maps").filter(map => map.displayPosition.toString() === this.getKioskProfile.data().defaultLocation)[0].mapName)
          this.$store.commit("setTouchRequest", {
            module: "Language Bar",
            action: "Change Language",
            response: "Language changed to Spanish",
            timeStamp: new Date(),
            requestType: "Touch",
          });
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style scoped>
.btnDim {
  width: 90%;
  padding-top: 15px;
  padding-bottom: 15px;
}
</style>